__turbopack_context__.v({
  "content": "layout-module__MzwK3q__content",
  "layout": "layout-module__MzwK3q__layout",
});
